import { render, staticRenderFns } from "./ResultCount.vue?vue&type=template&id=2c6560c6&scoped=true&"
import script from "./ResultCount.vue?vue&type=script&lang=js&"
export * from "./ResultCount.vue?vue&type=script&lang=js&"
import style0 from "./ResultCount.vue?vue&type=style&index=0&id=2c6560c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6560c6",
  null
  
)

export default component.exports